var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPencil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 10.5H10.5M6.89221 2.65586C6.89221 2.65586 6.89221 3.47317 7.70952 4.29048C8.52683 5.10779 9.34414 5.10779 9.34414 5.10779M3.65981 8.99404L5.37617 8.74884C5.62375 8.71347 5.85318 8.59876 6.03002 8.42192L10.1615 4.29048C10.6128 3.83909 10.6128 3.10724 10.1615 2.65585L9.34415 1.83854C8.89276 1.38715 8.16091 1.38715 7.70952 1.83854L3.57808 5.96998C3.40124 6.14682 3.28653 6.37625 3.25116 6.62383L3.00596 8.34019C2.95148 8.7216 3.2784 9.04852 3.65981 8.99404Z",
    stroke: "#FFBE1D",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencil);
export default __webpack_public_path__ + "static/media/pencil.964b85d7ba29f63937a3ccd00aac440f.svg";
export { ForwardRef as ReactComponent };